import { IDecisionKind } from 'APIPackage/DictionariesModule/interfaces/IDecisionKind';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryDecisionKindSelectOption = makeCreateDictionarySelectOption<IDecisionKind>('id', 'title');
